import { AlertListRow, AlertTrigger } from '@fullstory/proto/fs/services/dx-objects';
import { TrendFrequency } from '@fullstory/proto/fs/services/search-settings/visualizationsettings';
import { Timestamp } from '@fullstory/proto/google/protobuf';
import { addDays, addMonths } from 'date-fns';

export const getTrendDataset = (start: string, end: string, value: number) => ({
  displayEndDate: new Date(end),
  displayStartDate: new Date(start),
  endDate: new Date(end),
  startDate: new Date(start),
  value,
  comparisonId: '',
  isPartialPeriod: false,
});

const startDate = new Date('2023-06-01T00:00:00Z');
const startDateMonthly = new Date('2023-06-01T00:00:00Z');

export const mockDailyAlerts: AlertTrigger[] = [
  {
    triggerId: 'test',
    alertTimes: {
      start: Timestamp.fromDate(startDate),
      end: Timestamp.fromDate(addDays(startDate, 1)),
    },
    isHistorical: false,
    triggerValue: 0,
  },
  {
    triggerId: 'test2',
    alertTimes: {
      start: Timestamp.fromDate(addDays(startDate, 1)),
      end: Timestamp.fromDate(addDays(startDate, 2)),
    },
    isHistorical: false,
    triggerValue: 0,
  },
  {
    triggerId: 'test3',
    alertTimes: {
      start: Timestamp.fromDate(addDays(startDate, 2)),
      end: Timestamp.fromDate(addDays(startDate, 3)),
    },
    isHistorical: false,
    triggerValue: 0,
  },
  {
    triggerId: 'test4',
    alertTimes: {
      start: Timestamp.fromDate(addDays(startDate, 3)),
      end: Timestamp.fromDate(addDays(startDate, 4)),
    },
    isHistorical: false,
    triggerValue: 0,
  },
  {
    triggerId: 'test5',
    alertTimes: {
      start: Timestamp.fromDate(addDays(startDate, 4)),
      end: Timestamp.fromDate(addDays(startDate, 5)),
    },
    isHistorical: false,
    triggerValue: 0,
  },
];

export const mockMonthlyAlerts: AlertTrigger[] = [
  {
    triggerId: 'test',
    alertTimes: {
      start: Timestamp.fromDate(startDateMonthly),
      end: Timestamp.fromDate(addMonths(startDateMonthly, 1)),
    },
    isHistorical: false,
    triggerValue: 0,
  },
  {
    triggerId: 'test2',
    alertTimes: {
      start: Timestamp.fromDate(addMonths(startDateMonthly, 1)),
      end: Timestamp.fromDate(addMonths(startDateMonthly, 2)),
    },
    isHistorical: false,
    triggerValue: 0,
  },
  {
    triggerId: 'test3',
    alertTimes: {
      start: Timestamp.fromDate(addMonths(startDateMonthly, 2)),
      end: Timestamp.fromDate(addMonths(startDateMonthly, 3)),
    },
    isHistorical: false,
    triggerValue: 0,
  },
  {
    triggerId: 'test4',
    alertTimes: {
      start: Timestamp.fromDate(addMonths(startDateMonthly, 3)),
      end: Timestamp.fromDate(addMonths(startDateMonthly, 4)),
    },
    isHistorical: false,
    triggerValue: 0,
  },
  {
    triggerId: 'test5',
    alertTimes: {
      start: Timestamp.fromDate(addMonths(startDateMonthly, 4)),
      end: Timestamp.fromDate(addMonths(startDateMonthly, 5)),
    },
    isHistorical: false,
    triggerValue: 0,
  },
];

export const mockAlertTriggers: AlertTrigger[] = [
  {
    triggerId: '3CcsEYJn9n7N',
    alertTimes: {
      start: Timestamp.fromDate(new Date('2023-05-11T23:00:00Z')),
      end: Timestamp.fromDate(new Date('2023-05-12T00:00:00Z')),
    },
    isHistorical: false,
    triggerValue: 0.006918967052537846,
  },
  {
    triggerId: 'fHQDddmbtFjy',
    alertTimes: {
      start: Timestamp.fromDate(new Date('2023-05-11T18:00:00Z')),
      end: Timestamp.fromDate(new Date('2023-05-11T19:00:00Z')),
    },
    isHistorical: false,
    triggerValue: 0.0351515151515152,
  },
];

export const alertListFullAccess: AlertListRow[] = [
  {
    alertId: 'Hhi5aWuTK39b',
    alertName: 'metric alert 1',
    lastAlertTime: {
      start: Timestamp.fromMillis(50000),
      end: Timestamp.fromMillis(50000),
    },
    createdBy: {
      email: 'katie@fullstory.com',
      firstName: 'Katie',
      lastName: 'Merin',
    },
    destinationIds: [],
    metricId: '1',
    metricName: 'metric',
    timeZone: 'UTC',
    frequency: TrendFrequency.TREND_FREQUENCY_DAILY,
    accessControl: {
      id: '',
      canRead: true,
      canUpdate: true,
      canDelete: true,
      canCreate: true,
      owners: ['katie@fullstory.com'],
    },
    subscribedUsers: [
      {
        user: {
          email: 'johnverrone@fullstory.com',
          firstName: 'John',
          lastName: 'Verrone',
        },
        subscribedInApp: true,
        subscribedEmail: false,
      },
    ],
  },
  {
    alertId: 'Hhi5aWuTK39c',
    alertName: 'metric alert 2',
    lastAlertTime: {
      start: Timestamp.fromMillis(10000),
      end: Timestamp.fromMillis(10000),
    },
    createdBy: {
      email: 'johnverrone@fullstory.com',
      firstName: 'John',
      lastName: 'Verrone',
    },
    destinationIds: [],
    metricId: '1',
    metricName: 'metric',
    timeZone: 'UTC',
    frequency: TrendFrequency.TREND_FREQUENCY_DAILY,
    accessControl: {
      id: '',
      canRead: true,
      canUpdate: true,
      canDelete: true,
      canCreate: true,
      owners: ['johnverrone@fullstory.com'],
    },
    subscribedUsers: [
      {
        user: {
          email: 'johnverrone@fullstory.com',
          firstName: 'John',
          lastName: 'Verrone',
        },
        subscribedInApp: true,
        subscribedEmail: false,
      },
    ],
  },
  {
    alertId: 'Hhi5aWuTK39d',
    alertName: 'metric alert 3',
    lastAlertTime: {
      start: null,
      end: null,
    },
    createdBy: {
      email: 'webiii@fullstory.com',
      firstName: '',
      lastName: '',
    },
    destinationIds: [],
    metricId: '1',
    metricName: 'metric',
    timeZone: 'UTC',
    frequency: TrendFrequency.TREND_FREQUENCY_DAILY,
    accessControl: {
      id: '',
      canRead: true,
      canUpdate: true,
      canDelete: true,
      canCreate: true,
      owners: ['webiii@fullstory.com'],
    },
    subscribedUsers: [
      {
        user: {
          email: 'johnverrone@fullstory.com',
          firstName: 'John',
          lastName: 'Verrone',
        },
        subscribedInApp: true,
        subscribedEmail: false,
      },
    ],
  },
];

export const alertListNoAccess: AlertListRow[] = [
  {
    alertId: 'Hhi5aWuTK39b',
    alertName: 'metric alert 1',
    lastAlertTime: {
      start: Timestamp.fromMillis(50000),
      end: Timestamp.fromMillis(50000),
    },
    createdBy: {
      email: 'katie@fullstory.com',
      firstName: 'Katie',
      lastName: 'Merin',
    },
    destinationIds: [],
    metricId: '1',
    metricName: 'metric',
    timeZone: 'UTC',
    frequency: TrendFrequency.TREND_FREQUENCY_DAILY,
    accessControl: {
      id: '',
      canRead: true,
      canUpdate: false,
      canDelete: false,
      canCreate: false,
      owners: ['katie@fullstory.com'],
    },
    subscribedUsers: [
      {
        user: {
          email: 'johnverrone@fullstory.com',
          firstName: 'John',
          lastName: 'Verrone',
        },
        subscribedInApp: true,
        subscribedEmail: false,
      },
    ],
  },
  {
    alertId: 'Hhi5aWuTK39c',
    alertName: 'metric alert 2',
    lastAlertTime: {
      start: Timestamp.fromMillis(10000),
      end: Timestamp.fromMillis(10000),
    },
    createdBy: {
      email: 'johnverrone@fullstory.com',
      firstName: 'John',
      lastName: 'Verrone',
    },
    destinationIds: [],
    metricId: '1',
    metricName: 'metric',
    timeZone: 'UTC',
    frequency: TrendFrequency.TREND_FREQUENCY_DAILY,
    accessControl: {
      id: '',
      canRead: true,
      canUpdate: false,
      canDelete: false,
      canCreate: false,
      owners: ['johnverrone@fullstory.com'],
    },
    subscribedUsers: [
      {
        user: {
          email: 'johnverrone@fullstory.com',
          firstName: 'John',
          lastName: 'Verrone',
        },
        subscribedInApp: true,
        subscribedEmail: false,
      },
    ],
  },
  {
    alertId: 'Hhi5aWuTK39d',
    alertName: 'metric alert 3',
    lastAlertTime: {
      start: null,
      end: null,
    },
    createdBy: {
      email: 'webiii@fullstory.com',
      firstName: '',
      lastName: '',
    },
    destinationIds: [],
    metricId: '1',
    metricName: 'metric',
    timeZone: 'UTC',
    frequency: TrendFrequency.TREND_FREQUENCY_DAILY,
    accessControl: {
      id: '',
      canRead: true,
      canUpdate: false,
      canDelete: false,
      canCreate: false,
      owners: ['webiii@fullstory.com'],
    },
    subscribedUsers: [
      {
        user: {
          email: 'johnverrone@fullstory.com',
          firstName: 'John',
          lastName: 'Verrone',
        },
        subscribedInApp: true,
        subscribedEmail: false,
      },
    ],
  },
];
